// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__mhKyq","spin":"Spinner_spin__ikkq7"};